export const PROMOTIONALBANNERDATA_GET_REQUEST = 'PROMOTIONALBANNERDATA_GET_REQUEST';
export const PROMOTIONALBANNERDATA_GET_SUCCESS = 'PROMOTIONALBANNERDATA_GET_SUCCESS';
export const PROMOTIONALBANNERDATA_GET_ERROR = 'PROMOTIONALBANNERDATA_GET_ERROR';
export const IRIS_PROMOTIONALBANNERDATA_GET_REQUEST = 'IRIS_PROMOTIONALBANNERDATA_GET_REQUEST';
export const IRIS_PROMOTIONALBANNERDATA_GET_SUCCESS = 'IRIS_PROMOTIONALBANNERDATA_GET_SUCCESS';
export const IRIS_PROMOTIONALBANNERDATA_GET_ERROR = 'IRIS_PROMOTIONALBANNERDATA_GET_ERROR';
export const IRIS_PROMOTIONALBANNERDATA_GET_ERROR_FSH_FALLBACK =
    'IRIS_PROMOTIONALBANNERDATA_GET_ERROR_FSH_FALLBACK';
